/**
 * GCLID capture — port del sistema validado del WP (gclid-capture.js).
 * Lee el gclid de la URL al aterrizar, persiste 90 días en localStorage
 * y lo expone para los eventos de conversión (atribución Google Ads).
 */
const STORAGE_KEY = 'jalapenos_gclid'
const TTL_MS = 90 * 24 * 60 * 60 * 1000

export function captureGclid(): void {
  try {
    const gclid = new URLSearchParams(location.search).get('gclid')
    if (gclid) {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          gclid,
          captured: Date.now(),
          expires: Date.now() + TTL_MS,
          source: location.pathname,
        }),
      )
    }
    // Prune si expiró
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const data = JSON.parse(raw) as { expires?: number }
      if (data.expires && Date.now() > data.expires) localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    /* storage bloqueado: no-op */
  }
}

export function getGclid(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw) as { gclid?: string; expires?: number }
    if (!data.gclid || !data.expires || Date.now() > data.expires) return null
    return data.gclid
  } catch {
    return null
  }
}
